import axios from 'axios'

const state = {
  UutkMstr: {},
  UinfoHist: [],
  apprCompareListA: [],
  apprCompareListP: [],
  apprCompareListTimeP: []
}

const getters = {
  UutkMstr (state) {
    return state.UutkMstr
  },
  UinfoHist (state) {
    return state.UinfoHist
  },
  apprCompareListA (state) {
    return state.apprCompareListA
  },
  apprCompareListP (state) {
    return state.apprCompareListP
  },
  apprCompareListTimeP (state) {
    return state.apprCompareListTimeP
  }
}
const mutations = {
  loadUutkMstrInfo: async function () {
    const para = {
      user: window.sessionStorage.getItem('currentUserCode')
    }
    const { data: res } = await axios.post('/tk/getUserAllApprInfo', para)
    if (res.data) {
      state.UutkMstr = res.data[0]
    }
  },
  loadUinfoHist: async function () {
    const para = {}
    para.condition = [{
      qJoin: 'and',
      qField: 'uinfo_user',
      qOp: '=',
      qValue: window.sessionStorage.getItem('currentUserCode'),
      qType: 'string'
    }, {
      qJoin: 'and',
      qField: 'uinfo_read',
      qOp: '=',
      qValue: 0,
      qType: 'boolean'
    }]
    para.pageNo = 1
    para.pageNum = 10
    const { data: res } = await axios.post('/users/getListUinfoHist', para)
    state.UinfoHist = res.data.list
  },
  loadApprCompareListA: async function () {
    const paraA = {
      type: 'A'
    }
    const { data: resA } = await axios.post('/tk/getUserApprInfo', paraA)
    if (resA.data) {
      state.apprCompareListA = resA.data
    }
  },
  loadApprCompareListP: async function () {
    const paraP = {
      type: 'P'
    }
    const { data: resP } = await axios.post('/tk/getUserApprInfo', paraP)
    if (resP.data) {
      state.apprCompareListP = resP.data
    }
  },
  loadApprCompareListTime: async function () {
    const para = {
      type: 'A'
    }
    const { data: res } = await axios.post('/tk/getUserApprInfoTime', para)
    if (res.data) {
      state.apprCompareListTimeP = res.data
    }
  }
}
const actions = {
  loadAppInfoUser ({ commit }) {
    commit('loadUutkMstrInfo')
    commit('loadUinfoHist')
    commit('loadApprCompareListA')
    commit('loadApprCompareListP')
    commit('loadApprCompareListTime')
  }
}
export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state
}
